import { useLayoutEffect } from "react";
import { useLocation, useSearch } from "wouter";

import { INSTRUMENT_PARAM, INSTRUMENTS_PATH } from "../../paths";

const POSITIVE_ID = /^[1-9]\d*$/;

export const useInstrumentLink = (onLink: (instrumentId: number) => void) => {
  const search = useSearch();
  const [, navigate] = useLocation();

  useLayoutEffect(() => {
    const requested = new URLSearchParams(search).get(INSTRUMENT_PARAM);
    if (requested === null) {
      return;
    }
    if (POSITIVE_ID.test(requested)) {
      onLink(Number(requested));
    }
    navigate(INSTRUMENTS_PATH, { replace: true });
  }, [search, navigate, onLink]);
};
